(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ld66-home-gallery-life"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialise = (section) => {
    if (section.dataset.lifeReady === 'true') return;
    section.dataset.lifeReady = 'true';
    const triggers = [...section.querySelectorAll('[data-life-target]')];
    const panels = [...section.querySelectorAll('[data-life-panel]')];
    const images = [...section.querySelectorAll('[data-life-image]')];
    const show = (key) => {
      triggers.forEach((trigger) => {
        const active = trigger.dataset.lifeTarget === key;
        trigger.classList.toggle('is-active', active);
        trigger.setAttribute('aria-selected', String(active));
        trigger.setAttribute('aria-expanded', String(active));
      });
      images.forEach((image) => image.classList.toggle('is-active', image.dataset.lifeImage === key));
      panels.forEach((panel) => {
        const active = panel.dataset.lifePanel === key;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
    };
    const reset = () => {
      triggers.forEach((trigger) => {
        const active = trigger.dataset.lifeTarget === 'time';
        trigger.classList.toggle('is-active', active);
        trigger.setAttribute('aria-selected', String(active));
        trigger.setAttribute('aria-expanded', 'false');
      });
      images.forEach((image) => image.classList.toggle('is-active', image.dataset.lifeImage === 'time'));
      panels.forEach((panel) => {
        panel.classList.remove('is-active');
        panel.hidden = true;
      });
    };
    triggers.forEach((trigger, index) => {
      trigger.addEventListener('pointerenter', () => show(trigger.dataset.lifeTarget));
      trigger.addEventListener('focus', () => {
        if (trigger.matches(':focus-visible')) show(trigger.dataset.lifeTarget);
      });
      trigger.addEventListener('keydown', (event) => {
        if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let next = index;
        if (event.key === 'ArrowDown') next = (index + 1) % triggers.length;
        if (event.key === 'ArrowUp') next = (index - 1 + triggers.length) % triggers.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = triggers.length - 1;
        triggers[next].focus();
      });
    });
    section.addEventListener('pointerleave', reset);
  };
  document.querySelectorAll('[data-ld66-life]').forEach(initialise);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-ld66-life]').forEach(initialise);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
